var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"spinner-container"},[_c('h1',[_vm._v(_vm._s(_vm.text))]),_c('spinner')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }